import { signOut } from '@/lib/server/signOut.tsx';
import { resetAuthUser } from '@/routes/admin.tsx';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sign-out')({
  preload: false,
  loader: async ({ context: { queryClient } }) => {
    await signOut();
    resetAuthUser(queryClient);
    throw redirect({ to: '/sign-in' });
  },
});